import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo Api 回傳值
 */
export interface IdDocUploadResp extends GeneralResp {
    idCheck_P: string | null;
    idCheck_T: string | null;
    idCheck_Y: string | null;
    idCheck_M: string | null;
    idCheck_D: string | null;
}

/**
 * @todo 身分證件上傳
 */
const IdDocUpload = (postbackData: any): Promise<IdDocUploadResp> => {
    const url = RouteUrlList.API_IdDocUpload.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.true, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, postbackData, config).then((res: AxiosResponse<IdDocUploadResp>) => {
        return res.data;
    });
};

export default IdDocUpload;
